// action
import {
    GET_CONSULTATION_HISTORY,
    GET_CONSULTATION_HISTORY_FAIL,
    GET_CONSULTATION_HISTORY_SUCCESS,
    GET_CONSULTATION_HISTORY_RESET
} from '../action/getConsultationHistoryAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
    switch (action.type) {
        case GET_CONSULTATION_HISTORY:
            return {
                ...state,
                apiState: "loading"
            }
        case GET_CONSULTATION_HISTORY_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_CONSULTATION_HISTORY_SUCCESS: 
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
            }
        case GET_CONSULTATION_HISTORY_RESET:
            return initialState
        default:
            return {
                ...state
            }
    }
}